import React from 'react';
import { Slider, TextField, Tooltip } from '@mui/material';
import { BsQuestionCircle } from 'react-icons/bs';
import IntlMessages from 'util/IntlMessages';

const FinalSoc: React.FC<{
  socLimit: number;
  setSocLimit: (newSocLimit: number) => void;
  disabled: boolean;
}> = ({ socLimit, setSocLimit, disabled }) => {
  return (
    <>
      <div className="d-flex align-items-center w-100 mb-3" style={{ gap: '8px' }}>
        <h4 className="m-0">
          <IntlMessages id="components.connector-details.charge-final-soc" />
        </h4>
        <Tooltip
          disableInteractive
          placement="top"
          title={<IntlMessages id="components.connector-details.auto-start-disclaimer" />}
        >
          <div>
            <BsQuestionCircle />
          </div>
        </Tooltip>
      </div>
      <div className="d-flex align-items-center justify-content-center slider-container mb-3">
        <Slider
          disabled={disabled}
          className="mr-3"
          value={socLimit}
          onChange={(_event, newValue) => setSocLimit(newValue as number)}
        />
        <TextField
          disabled={disabled}
          label="Limit charge"
          type="number"
          value={socLimit}
          size="small"
          className="text-center hide-label"
          variant="outlined"
          onChange={(event) => setSocLimit(parseInt(event.target.value))}
          InputLabelProps={{
            shrink: false,
          }}
          hiddenLabel={true}
        />
      </div>
    </>
  );
};
export default FinalSoc;
